import React from "react";
import AiContentSlot from "./AiContentSlot";

export function getEventAiContentBlockId(event) {
    return event?.aiContentBlockId
        || event?.annualEventPage?.customContent?.aiContentBlockId
        || null;
}

export default function EventAiContent({ event, context, className, style }) {
    const blockId = getEventAiContentBlockId(event);
    if (!blockId) return null;

    const lang = context?.lang?.value || context?.langValue || context?.lang || "fr";
    return (
        <div className={className} style={style}>
            <AiContentSlot blockId={blockId} lang={lang} />
        </div>
    );
}
